import ApiService from '@/services/common/api.service';

const CashService = {
    getCash,
    getCashDetail,
    getCashCurrency,
    getSummary,
    downloadExcel,
    exportExcel,
};

async function getCash (query = "") {
    let url = '/cash';
    if (query) {
        url += "?tourNumber=" + query;
    }
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function getCashDetail (cashDmosId, tourNumber) {
    let url = '/cash/' + cashDmosId + "?tourNumber=" + tourNumber;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function getCashCurrency (cashCurrencyId) {
    let url = '/cash/cash-currency/' + cashCurrencyId;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function getSummary (cashId) {
    try {
        let requestData = {
            method: 'get',
            url: `${process.env.API_URL}/cash/summary?cashId=` + cashId,
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    }catch (error) {
        return error;
    }
}

async function downloadExcel (cashId, tourInfo) {
    try {
        let requestData = {
            method: 'get',
            responseType: 'blob',
            url: `${process.env.API_URL}/cash/download-excel?cashId=` + cashId + `&tourInfo=` + encodeURIComponent(JSON.stringify(tourInfo)),
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    }catch (error) {
        return error;
    }
}

async function exportExcel (cashId, tourInfo) {
    try {
        let url = `${process.env.API_URL}/cash/` + cashId + `/excel/`;
        const prot = window.location.protocol;
        if (prot === "https:") {
            url = url.replace("http", "https");
        };
        // let response = await ApiService.customRequest(requestData);
        let response = await ApiService.post(url, tourInfo);
        return response;
    } catch (error) {
        return error;
    }
}

export default CashService;



// WEBPACK FOOTER //
// ./src/services/module/cash.service.js